export default [
    {
        routeName: 'offerFlow-steps-twocol-date',
        name: 'offerFlow.pages.stepDate.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-trip-selection',
        name: 'offerFlow.pages.stepTripSelection.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.pages.stepPassengers.name.common',
        skipIfUpsell: true,
    },
] as ProductFlowStep[];
